import { ARYA_SHAKTI_NUMBER } from "./types";

export const setAryaShaktiMobileInfo = (payload) => {
  return { type: ARYA_SHAKTI_NUMBER, payload };
};
